/*
 * Check if the key 'state' exists in sessionStorage
 *
 * @return {Object} - If 'state' exists, parse it and return the object
 * @return {undefined} - If 'state' does not exist, return undefined
 *
 * @since 1.0.0
 */

export const loadState = () => {
  try {
    const serializedState = sessionStorage.getItem('kleekamp_1485046775195');

    if (serializedState === null) {
      return undefined;
    }

    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
}




/*
 * Save state to sessionStorage
 *
 * @since 1.0.0
 */

export const saveState = state => {
  try {
    const serializedState = JSON.stringify(state);
    sessionStorage.setItem('kleekamp_1485046775195', serializedState)
  } catch (err) {}
}




// WEBPACK FOOTER //
// ./app/src/sessionStorage.js